import React from "react";
import "./UiButton.css";

const UI_BUTTON_TYPE = {
  NORMAL: "normal",
  NO_BORDER: "no-border",
  ONLY_BORDER: "only-border",
  BG_WHITE: "bg-white",
  ACTIVE: "btn-active",
  INACTIVE: "btn-inactive",
  BLACK_BORDER: "black-border",
};
export { UI_BUTTON_TYPE };

const UiButton = ({
  content,
  onClick = () => {},
  buttonUiType = [UI_BUTTON_TYPE.NORMAL],
  type = "button",
  disabled = false,
  classNames = [],
  size,
  style,
  variant,
  id,
  ...props
}) => {
  const buttonUiTypeSet = new Set(Object.values(UI_BUTTON_TYPE));
  const buttonUiTypeClass = buttonUiType
    .filter((type) => buttonUiTypeSet.has(type))
    .join(" ");
  const classNamesSet = new Set(classNames);
  function buttonClick(e) {
    e.preventDefault();
    e.stopPropagation();
    onClick(e);
  }

  classNames = Array.from(classNamesSet).join(" ");

  if (size) classNames += ` btn-${size} `;
  if (variant) classNames += ` btn-${variant} `;

  const buttonClassNames = `btn ui-button ${buttonUiTypeClass} ${classNames}`;
  return (
    <React.Fragment>
      <button
        className={buttonClassNames}
        style={style}
        onClick={buttonClick}
        disabled={disabled}
        type={type}
        id={id}
        {...props}
      >
        {content}
      </button>
    </React.Fragment>
  );
};

export default UiButton;
